import axios from 'axios'

export default {
  getSensedQuakes () {
    return axios.get('http://data.bmkg.go.id/gempadirasakan.xml')
  },
  getRecentQuakes () {
    return axios.get('http://data.bmkg.go.id/autogempa.xml')
  }
}
